import { render, staticRenderFns } from "./TestResultPage.vue?vue&type=template&id=6f9d6353&scoped=true&"
import script from "./TestResultPage.vue?vue&type=script&lang=js&"
export * from "./TestResultPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d6353",
  null
  
)

export default component.exports